import React, { useCallback, useEffect, useState } from 'react'
import { apiClient as axios } from './apiClient';
import { clearSupportSession } from './authSession';

const withTenant = (Component) => {

    const Wrapper =  (props)=>{ 
        const pathname = window.location.pathname;
        const usernameTenant  = pathname.split('/')[1];
        const [isTenant,setIsTenant] = useState(false);

        const getTenant = useCallback(async() => {
            try{
                const res = await axios.get(`${process.env.REACT_APP_Auth_API_BASE_URL}/tenants/username/${usernameTenant}`);
                const tenantData = res?.data?.data;
                if(tenantData){
                    localStorage.setItem('tenant',JSON.stringify(tenantData));
                    setIsTenant(true);
                    return;
                }
            }catch(err){
            }

            try {
                const cachedTenant = JSON.parse(localStorage.getItem('tenant') || 'null');
                if(cachedTenant && cachedTenant?.username === usernameTenant){
                    setIsTenant(true);
                    return;
                }
            } catch {
            }

            if (usernameTenant) {
                clearSupportSession({ preserveToken: true });
            }
            if (localStorage.getItem('tenant')) {
                setIsTenant(true);
                return;
            }
            window.location.replace(`${process.env.REACT_APP_Auth_WEB_BASE_URL}`)
        }, [usernameTenant]);
        useEffect(()=>{
           
            getTenant();
        },[getTenant]);

        if(isTenant){
            //console.log('withTenant: => is Ready');
            return   <Component {...props} /> 
        }
        

    }
    return Wrapper;
}

export default withTenant
